module.exports = __webpack_public_path__ + "static/media/th-parachute-1.99c7c414.svg";